import { TriAuthService } from "@onetakesolutions/cargogo-contract-web/TriAuthService_dubbo";
import { createPromiseClient } from "@apachedubbo/dubbo";
import transport from "./transport";

const client = createPromiseClient(TriAuthService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
